<template>
<!-- eslint-disable -->
<!-- Icon made by Pixel perfect from www.flaticon.com -->
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512.014 512.014" style="enable-background:new 0 0 512.014 512.014;" xml:space="preserve">
<g>
	<g>
		<path d="M304.014,144.007h-192c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h192c8.832,0,16-7.168,16-16
			C320.014,151.175,312.846,144.007,304.014,144.007z"/>
	</g>
</g>
<g>
	<g>
		<path d="M240.014,208.007h-128c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h128c8.832,0,16-7.168,16-16
			C256.014,215.175,248.846,208.007,240.014,208.007z"/>
	</g>
</g>
<g>
	<g>
		<path d="M208.014,16.007c-114.688,0-208,78.944-208,176c0,39.84,15.68,77.952,44.48,108.896L4.686,340.679
			c-4.576,4.576-5.952,11.456-3.456,17.44c2.496,5.984,8.32,9.888,14.784,9.888h192c114.688,0,208-78.944,208-176
			S322.702,16.007,208.014,16.007z M208.014,336.007H54.638l23.872-23.904c3.104-3.104,4.832-7.328,4.704-11.712
			c-0.128-4.384-2.048-8.544-5.312-11.488c-29.568-26.624-45.888-61.024-45.888-96.896c0-79.392,78.976-144,176-144
			s176,64.608,176,144S305.038,336.007,208.014,336.007z"/>
	</g>
</g>
<g>
	<g>
		<path d="M467.566,428.871c28.768-30.912,44.448-69.024,44.448-108.864c0-37.12-13.632-72.704-39.36-102.88
			c-5.76-6.72-15.84-7.456-22.528-1.792c-6.72,5.728-7.52,15.84-1.792,22.56c20.704,24.32,31.68,52.704,31.68,82.112
			c0,35.872-16.32,70.272-45.888,96.896c-3.296,2.944-5.184,7.072-5.312,11.456c-0.128,4.384,1.6,8.64,4.672,11.744l23.904,23.904
			H304.014c-64.992,0-124.512-29.216-155.232-76.256c-4.896-7.424-14.848-9.472-22.144-4.64c-7.392,4.832-9.472,14.752-4.672,22.144
			c36.608,55.968,106.368,90.752,182.048,90.752h192c6.464,0,12.32-3.904,14.784-9.888c2.464-5.984,1.088-12.864-3.456-17.44
			L467.566,428.871z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>

<script>
export default {
  name: 'CommentsIcon'
};
</script>
